import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import Input from '../components/Input';
import Background from './../images/bg.jpg';
import TSLogo from './../images/ts-logo.png';
import Image from './../images/bg-2.png';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { apiPost } from '../api/apiClient';
import { AUTH } from '../api/endpoints';

const ResetPassword = () => {
    const { jwtToken } = useAuth();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();

        setError("");
        setSuccess("");

        if (!password.trim()) {
            setError("Password harus diisi.");
            return;
        }

        if (!confirmPassword.trim()) {
            setError("Konfirmasi password harus diisi.");
            return;
        }

        if (password !== confirmPassword) {
            setError("Password tidak sama.");
            return;
        }

        setIsLoading(true);
        try {
            const result = await apiPost(AUTH.RESET_PASSWORD, {
                token: token,
                password: password
            });

            if (result.error) {
                setError(result.message);
            } else {
                setSuccess("Password berhasil diubah. Mohon login kembali.");
            }
        } catch (err) {
            setError(err?.response?.data?.message || "Terjadi kesalahan. Coba lagi.");
        }

        setIsLoading(false);
    };

    useEffect(() => {
        if (!confirmPassword) return;

        if (password !== confirmPassword) {
            setError("Password tidak sama.");
        } else {
            setError("");
        }
    }, [password, confirmPassword]);

    useEffect(() => {
        if (jwtToken !== "") {
            navigate("/");
        }
    }, [jwtToken, navigate]);

    return (
        <>
            <div className="relative flex justify-center items-center h-screen">
                <img src={Background} alt="Background" className="absolute inset-0 object-cover w-full h-full -z-20" />
                <div className="absolute inset-0 bg-red-600 opacity-60 -z-10"></div>
                <div className="flex lg:grid lg:grid-cols-2 gap-10 xl:gap-24 items-start">
                    {/* <img src={Logo} className="absolute top-0 left-0 w-48 h-auto m-5 p-2 hover:shadow-lg" alt="Student" /> */}
                    <div className="hidden lg:flex items-center justify-center">
                        <h1 className="flex flex-col font-extrabold text-white absolute top-32">
                            <div className="flex gap-3 items-center justify-center">
                                <img src={TSLogo} className="w-32 h-auto" alt="Student" />
                                <div className="flex flex-col">
                                    <span className="text-xl [text-shadow:_-3px_5px_0_#000]">Portal Alumni</span>
                                    <span className="text-5xl [text-shadow:_-3px_5px_0_#000]">SMA Telkom</span>
                                    <span className="text-5xl mb-3 [text-shadow:_-3px_5px_0_#000]">Bandung</span>
                                </div>
                            </div>
                            <div className="text-xl xl:text-2xl [text-shadow:_-3px_5px_0_#000] mt-4">"Maju Bersama Hebat Semua. GEN BIRU Juara!"</div>
                        </h1>
                        <img src={Image} className="absolute bottom-0 w-[360px] h-auto" alt="Student" />
                    </div>
                    <div className="flex justify-center xl:px-12 w-full lg:min-w-[450px] xl:min-w-[525px]">
                        <div className="flex flex-col w-full bg-white shadow-lg shadow-black py-8 px-10 border-2 border-black">
                            <h2 className="text-2xl font-extrabold mb-4">Reset Password</h2>
                            <form onSubmit={handleSubmit} className="mb-5">
                                <Input
                                    title="Password"
                                    labelClassName="font-bold"
                                    type="password"
                                    name="password"
                                    placeHolder="Enter your Password"
                                    onChange={(event) => setPassword(event.target.value)}
                                    className="w-full px-3 py-2 border border-black focus:border-blue-500 focus:ring-blue-500"
                                ></Input>
                                <Input
                                    title="Konfirmasi Password"
                                    labelClassName="font-bold"
                                    type="password"
                                    name="confirm_password"
                                    placeHolder="Enter your Password"
                                    onChange={(event) => setConfirmPassword(event.target.value)}
                                    className="w-full px-3 py-2 border border-black focus:border-blue-500 focus:ring-blue-500"
                                ></Input>
                                <div className={`mb-3 text-sm font-medium ${error ? "text-red-500 dark:text-red-400" : success ? "" : "invisible"}`} role="alert">
                                    {error || success || "placeholder"}
                                </div>
                                <button
                                    type="submit"
                                    className="text-white text-sm text-center py-3 px-7 bg-black font-bold hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 disabled:bg-gray-400"
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Loading...' : 'Kirim'}
                                </button>
                            </form>
                            <div className="text-sm">Sudah punya akun? <Link to="/login" className="font-semibold text-red-500 hover:underline">Login</Link></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default ResetPassword;